<template>
    <div>
        <div class="card dashcard mb-0">
            <div class="card-body">
                <div class="form-row">
                    <div class="col col-12 col-md-6">
                        <az-periodo v-model="filtro" :sync="true" @sync="load()" />
                    </div>
                    <div class="col col-12 col-md-2">
                        <az-input
                            :edicao="!enfermagem"
                            type="select" 
                            optionsMode="json"
                            :optionsList="[
                                { id: 'R', search: 'Referência' },
                                { id: 'A', search: 'Atendimento' },
                                { id: 'M', search: 'Marcação' },
                            ]"
                            optionsData="id"
                            placeholder="Prescrição"
                            icon="fa fa-calendar-check-o fa-fw" 
                            v-model="filtro.tipo_data" />
                    </div>
                    
                    <div class="col col-12" :class="enfermagem ? 'col-md-4' : 'col-md-2'">
                        <div class="input-group mb-1">
                            <div class="input-group-prepend">
                                <span class="input-group-text" id="basic-addon1">
                                    <i class="fa fa-building fa-fw" aria-hidden="true"></i>
                                </span>
                            </div>
                            <select class="form form-control" v-model="filtro.id_unidade_operacao">
                                <option value="">Unidades...</option>
                                <option v-for="(und, iux) in $util.unidades_com_tags(false, true)" 
                                    :value="und.id_unidade_operacao" :key="iux">{{ und.search }}</option>
                            </select>
                        </div>
                    </div>

                    <div class="col col-12 col-md-2" v-if="!enfermagem">
                        <az-input
                            icon="fa-solid fa-stamp"
                            placeholder="Status Autoriz..."
                            type="select"
                            optionsMode="json"
                            :optionsList="lista_status_autorizacao.filter(item => item.id != 9)"
                            optionsData="id"
                            v-model="filtro.status_autorizacao">
                        </az-input>
                    </div>

                </div>

                <div class="form-row mt-2">

                    <div class="col col-12 col-md-4">
                        <az-input
                            icon="fa fa-filter fa-fw"
                            type="select"
                            :optionsList="filas.map(item => { return { id: item.id_fila_laudo, search: item.search } })"
                            optionsData="id"
                            optionsDisplay="search"
                            v-model="filtro.id_fila_laudo"
                            :edicao="!$store.state.loading"
                            @input="load()" />
                    </div>
                    <div class="col col-12 col-md-4">
                        <az-input icon="fas fa-user-md fa-fw" 
                            type="select" 
                            placeholder="Todos os Médicos..."
                            optionsMode="aql"
                            service="medicos.index"
                            optionsName="medicos-cadastro"
                            :optionsParm="{ ativos: true }"
                            optionsData="id_pessoa"
                            v-model="filtro.id_medico" />
                    </div> 
                
                    <div class="col col-12 col-md-4" v-if="dados && dados.lista_status && dados.lista_status.length">
                        <az-input   
                            icon="fa fa-filter fa-fw"
                            type="select"
                            placeholder="Todos os Status..."
                            :optionsList="dados.lista_status"  
                            optionsData="id_contato_status"
                            optionsDisplay="search"
                            v-model="filtro.id_contato_status" />
                    </div>
                </div>

                <div class="form-row mt-2">
                    <div class="col col-12 col-md-4">
                        <az-input
                            placeholder="Todos os Procedimentos..."
                            icon="fa fa-play fa-fw"
                            type="select"
                            service="procedimentos.index"
                            optionsMode="aql"
                            optionsData="id_procedimento"
                            :optionsParm="{ agenda: true, infusao: true }"
                            v-model="filtro.id_procedimento_protocolo" />
                    </div>
                    
                    <div class="col col-12 col-md-4">
                        <az-input 
                            placeholder="Selecionar paciente..."
                            icon="fas fa-user"
                            type="autocomplete" 
                            optionsMode="aql"
                            service="pacientes.index"
                            optionsDisplay="search"
                            ref="info_paciente"
                            v-model="filtro.paciente" 
                            :optimized_ac="true">
                            <template v-slot:buttonposb>
                                <div class="input-group-append">
                                    <template v-if="filtro.paciente">
                                        <button type="button" class="btn btn-outline-primary" @click="abrir_perfil(filtro.paciente)">
                                            <i class="fa-solid fa-id-badge"></i>
                                        </button>
                                        <button type="button" class="btn btn-outline-primary" title="Incluir Prescrição" @click="novo_avulso()">
                                            <i class="fa-solid fa-plus"></i>
                                        </button>
                                    </template>
                                    <template v-else>
                                        <button type="button" class="btn btn-outline-primary" title="Incluir Paciente" @click="incluir_paciente()">
                                            <i class="fa-solid fa-plus"></i>
                                        </button>
                                    </template>
                                </div>
                            </template>
                        </az-input>
                    </div>

                    <div class="col col-12 col-md-4">
                        <az-input
                            icon="fa fa-search fa-fw"
                            placeholder="Pesquisar..."
                            v-model="search" />       
                    </div>
                </div>
            </div>
        </div>

        <div class="progress mt-1 mb-3">
            <div class="indeterminate" v-if="$store.state.loading && dados"></div>
            <div class="determinate" v-else></div>
        </div>

        <div v-if="lista_por_status && lista_por_status.length" class="mb-3">
            <a href="#" @click.prevent="filtrar_status(item.id_contato_status)" v-for="(item, idx) in lista_por_status" :key="idx">
                <span class="badge mr-1" :class="'badge-' + item.cor" >
                    {{ item.titulo }} / {{ item.qtde }}
                </span>
            </a>
        </div>

        <az-empty-state v-if="!lista.length" />

        <table class="table bg-white">
            <tbody v-for="(receita, index) in lista" :key="'P' + index">
                <tr>
                    <td>
                        <div class="row">
                            <div class="col col-12 col-md-6">
                                <div>
                                    <a href="#" @click.prevent="$root.perfil(receita.anamnese.atendimento_procedimento.atendimento.paciente)" class="mr-2">
                                        <i class="fa fa-id-badge" aria-hidden="true"></i>
                                    </a>
                                    <a href="#" @click.prevent="receita.exibido = !receita.exibido" class="card-link">
                                        {{ receita.anamnese.atendimento_procedimento.atendimento.paciente.st_nome }}
                                    </a>
                                    <small class="text-muted">
                                        {{ receita.anamnese.atendimento_procedimento.atendimento.paciente.cadastro.sexo }},
                                        {{ receita.anamnese.atendimento_procedimento.atendimento.paciente.cadastro.idade }}
                                    </small>
                                </div>
                                <div class="small" v-if="receita.anamnese.atendimento_procedimento.atendimento.plano">{{ receita.anamnese.atendimento_procedimento.atendimento.plano.search }}</div>
                                <div class="small">{{ receita.anamnese.atendimento_procedimento.atendimento.medico.search }}</div>
                                <div class="small">
                                    {{ $util.getFormatDate(receita.anamnese.atendimento_procedimento.atendimento.dt_inicio) }}
                                    <span v-if="receita.dt_valid_ini && receita.dt_valid_fim" title="Validade da Prescrição">
                                        | {{ $util.getFormatDate(receita.dt_valid_ini) }} {{ receita.dt_valid_ini.slice(11,16) }}
                                        - {{ $util.getFormatDate(receita.dt_valid_fim) }} {{ receita.dt_valid_fim.slice(11,16) }}
                                    </span>
                                </div>
                            </div>
                            <div class="col col-12 col-md-3">
                                <div class="small mb-2" v-if="receita.anamnese.atendimento_procedimento.procedimento">
                                    <div class="d-flex justify-content-between">
                                        <div>
                                            {{ receita.anamnese.atendimento_procedimento.procedimento.search }}

                                            <template v-if="receita.anamnese.atendimento_procedimento.procedimento.id_classe_procedimento == 1 && receita.anamnese.atendimento_procedimento.ch_tipo_consulta">
                                                <span
                                                    class="badge badge-pill"
                                                    :class="receita.anamnese.atendimento_procedimento.ch_tipo_consulta == 'R' ? 'badge-danger' 
                                                        : ( receita.anamnese.atendimento_procedimento.ch_tipo_consulta == 'P' ? 'badge-info' : 'badge-warning' )"
                                                    data-toggle2="tooltip"
                                                    data-placement="top"
                                                    :title="receita.anamnese.atendimento_procedimento.ch_tipo_consulta == 'I' ? 'Inicial' : ( 
                                                                receita.anamnese.atendimento_procedimento.ch_tipo_consulta == 'R' ? 'Revisão' : ( 
                                                                receita.anamnese.atendimento_procedimento.ch_tipo_consulta == 'S' ? 'Subsequente' : ( 
                                                                receita.anamnese.atendimento_procedimento.ch_tipo_consulta == 'P' ? 'Pré-Natal' : '' 
                                                                ) ) )">
                                                    {{ receita.anamnese.atendimento_procedimento.ch_tipo_consulta }}
                                                </span>
                                            </template>
                                        </div>

                                        <span class="ml-2" v-if="receita.anamnese.atendimento_procedimento.atendimento.marcacao && receita.anamnese.atendimento_procedimento.atendimento.marcacao.st_observacoes">
                                            <az-float-panel
                                                classe="right"
                                                title="Observações"
                                                icon="fas fa-file-alt">
                                                <small class="lead">{{ receita.anamnese.atendimento_procedimento.atendimento.marcacao.st_observacoes }}</small>
                                            </az-float-panel>
                                        </span>
                                    </div>
                                    <div v-if="receita.anamnese.atendimento_procedimento.atendimento.marcacao && receita.anamnese.atendimento_procedimento.atendimento.marcacao.infusao">
                                        {{ receita.anamnese.atendimento_procedimento.atendimento.marcacao.infusao.st_titulo }}
                                    </div>
                                    <div class="text-muted">
                                        #{{ receita.anamnese.atendimento_procedimento.id_atendimento }}
                                        <span class="badge badge-light ml-2" v-if="receita.anamnese.atendimento_procedimento.atendimento.marcacao && receita.anamnese.atendimento_procedimento.atendimento.marcacao.unidade_operacao">
                                            {{ receita.anamnese.atendimento_procedimento.atendimento.marcacao.unidade_operacao.st_sigla }}
                                        </span>
                                        <span class="badge badge-light ml-2" v-else-if="receita.anamnese.atendimento_procedimento.atendimento.avulso && receita.anamnese.atendimento_procedimento.atendimento.avulso.unidade_operacao">
                                            {{ receita.anamnese.atendimento_procedimento.atendimento.avulso.unidade_operacao.st_sigla }}
                                        </span>
                                    </div>
                                </div>
                                
                                <template v-if="receita.editada">
                                    <div v-if="receita.editada.kit" class="small">{{ receita.editada.kit.st_nome }}</div>
                                    <div v-if="receita.editada.procedimento" class="small">{{ receita.editada.procedimento.search }}</div>    
                                </template>
                                <template v-else>
                                    <div v-if="receita.kit" class="small">{{ receita.kit.st_nome }}</div>
                                    <div v-if="receita.procedimento" class="small">{{ receita.procedimento.search }}</div>
                                </template>

                                <template v-if="receita.anamnese.atendimento_procedimento.atendimento.internacao">
                                    <div class="small" v-if="receita.anamnese.atendimento_procedimento.atendimento.internacao.local">
                                        <i class="fas fa-bed fa-fw mr-2"></i>
                                        <template v-if="receita.anamnese.atendimento_procedimento.atendimento.internacao.local.st_sigla">
                                            {{ receita.anamnese.atendimento_procedimento.atendimento.internacao.local.st_sigla }}
                                        </template>
                                        <template v-else>
                                            {{ receita.anamnese.atendimento_procedimento.atendimento.internacao.local.search }}
                                        </template>
                                    </div>
                                    <div class="small" v-if="receita.anamnese.atendimento_procedimento.atendimento.internacao.local_momento">
                                        <i class="fa-solid fa-street-view fa-fw mr-2"></i>
                                        <template v-if="receita.anamnese.atendimento_procedimento.atendimento.internacao.local_momento.st_sigla">
                                            {{ receita.anamnese.atendimento_procedimento.atendimento.internacao.local_momento.st_sigla }}
                                        </template>
                                        <template v-else>
                                            {{ receita.anamnese.atendimento_procedimento.atendimento.internacao.local_momento.search }}
                                        </template>                                           
                                    </div>
                                </template>
                            </div>
                            <div class="col col-12 col-md-3 text-right">
                                <div>
                                    <span v-if="receita.contato && receita.valid_id_marcacao && ( receita.valid_id_marcacao == receita.contato.id_marcacao )" title="Validação da Prescrição para Marcação" class="mr-2">
                                        <i class="fa-regular fa-calendar-check text-success"></i>
                                    </span>

                                    <a href="#" @click.prevent="filtrar_status(receita.contato.id_contato_status)" v-if="receita.contato" class="h5 mb-0">
                                        <span class="badge" :class="'badge-' + cor_contato(receita)">
                                            {{ receita.contato.contato_status.search }}
                                            / {{ quando(receita.contato.created_at) }}
                                        </span>
                                    </a>

                                    <a href="#" @click.prevent="filtrar_status('R')" v-else class="h5 mb-0">
                                        <span class="badge badge-secondary">Registrado</span>
                                    </a>

                                    <div class="mt-1">
                                        <a href="#" @click.prevent="editar_peso_altura(receita)" class="btn btn-sm btn-outline-primary mr-1" title="Peso/Altura" v-if="receita.exibido">
                                            <i class="fa-solid fa-weight-scale"></i>
                                        </a>

                                        <button class="btn btn-sm btn-outline-primary mr-1" type="button" @click="resumo_medicamentos(receita)" title="Histórico de Medicamentos">
                                            <i class="fa-solid fa-book-medical"></i>
                                        </button>

                                        <a href="#" @click.prevent="receita.exibido = !receita.exibido" class="btn btn-sm btn-outline-primary mr-1" title="Ocultar/Exibir Prescrição">
                                            <i class="fa-solid fa-eye" v-if="receita.exibido"></i>
                                            <i class="fa-solid fa-eye-slash" v-else></i>
                                        </a>

                                        <span v-if="receita.contatos">
                                            <a href="#" @click.prevent="abrir_contatos(receita)" class="btn btn-sm btn-outline-primary mr-1" title="Registrar Validação">
                                                <i class="fa-solid fa-comment-medical mr-1"></i>
                                                {{ receita.contatos.length }}
                                            </a>
                                        </span>

                                        <button type="button" class="btn btn-outline-primary btn-sm" @click="agendar_infusao(receita)" title="Agendar" v-if="!enfermagem">
                                            Agenda
                                        </button>
                                    </div>

                                    <div v-if="receita.exibido" class="small text-muted text-right" title="Id da Prescrição">
                                        ({{ receita.id_receita }})
                                    </div>

                                    <div v-else class="text-right">
                                        <span v-if="receita.protocolo" class="text-right">
                                            <span class="badge badge-dark" v-if="receita.editada && receita.editada.id_marcacao_edicao">
                                                Prescrição da Sessão (M{{ receita.editada.id_marcacao_edicao }})
                                            </span>
                                            <span class="badge badge-dark" v-else>
                                                Prescrição do Protocolo
                                            </span>
                                        </span>

                                        <span v-else-if="is_receita_de_sessao(receita)" class="text-right">
                                            <span class="badge badge-warning">
                                                Prescrição da Sessão
                                            </span>
                                        </span>
                                    </div>
                                </div>

                                <template v-if="false">

                                    <template v-if="receita.exibido">
                                        <az-submit color="outline-success btn-sm" @click="checar(receita)">
                                            <i class="fa fa-check" aria-hidden="true"></i>
                                        </az-submit>
                                    </template>
                                    <template v-else>
                                        <div>
                                            <a href="#" class="alert-link mb-2" :class="receita.solicitacao ? 'text-success' : 'text-secondary'" title="Solicitar Mat/Med." @click.prevent="solicitar_matmed(receita)">
                                                <i class="fa-solid fa-boxes-packing"></i>
                                            </a>
                                        </div>

                                        <h5 v-for="(items, status, irx) in stat_horarios(receita)" :key="irx">
                                            <span class="badge badge-secondary" v-if="status == 'A'">
                                                <i class="fa fa-question-circle" aria-hidden="true"></i>
                                                <span class="ml-2">{{ items.length }}</span>
                                            </span>
                                            <span class="badge badge-success" v-if="status == 'X'">
                                                <i class="fa fa-check-circle" aria-hidden="true"></i>
                                                <span class="ml-2">{{ items.length }}</span>
                                            </span>
                                            <span class="badge badge-warning" v-if="status == 'R'">
                                                <i class="fa fa-exclamation-circle" aria-hidden="true"></i>
                                                <span class="ml-2">{{ items.length }}</span>
                                            </span>
                                            <span class="badge badge-danger" v-if="status == 'C'">
                                                <i class="fa fa-times-circle" aria-hidden="true"></i>
                                                <span class="ml-2">{{ items.length }}</span>
                                            </span>
                                        </h5>
                                    </template>

                                </template>
                            </div>
                        </div>

                        <div class="d-flex justify-content-between" v-if="false">
                            <div>
                                <div>
                                    <a href="#" @click.prevent="receita.exibido = !receita.exibido" class="card-link">
                                        {{ receita.anamnese.atendimento_procedimento.atendimento.paciente.st_nome }}
                                    </a>
                                    <small class="text-muted">
                                        {{ receita.anamnese.atendimento_procedimento.atendimento.paciente.cadastro.sexo }},
                                        {{ receita.anamnese.atendimento_procedimento.atendimento.paciente.cadastro.idade }}
                                    </small>
                                </div>
                                <div class="small" v-if="receita.anamnese.atendimento_procedimento.atendimento.plano">{{ receita.anamnese.atendimento_procedimento.atendimento.plano.search }}</div>
                                <div class="small">{{ receita.anamnese.atendimento_procedimento.atendimento.medico.search }}</div>
                            </div>
                            <div class="text-right">
                                <div class="small mb-2" v-if="receita.anamnese.atendimento_procedimento.procedimento">
                                    #{{ receita.anamnese.atendimento_procedimento.id_atendimento }}
                                    <i class="fa fa-caret-right mx-2" aria-hidden="true"></i>
                                    {{ receita.anamnese.atendimento_procedimento.procedimento.search }}
                                    <template v-if="receita.anamnese.atendimento_procedimento.atendimento.marcacao && receita.anamnese.atendimento_procedimento.atendimento.marcacao.infusao">
                                        <i class="fa fa-caret-right mx-2" aria-hidden="true"></i>
                                        {{ receita.anamnese.atendimento_procedimento.atendimento.marcacao.infusao.st_titulo }}
                                    </template>
                                </div>
                                
                                <template v-if="receita.exibido">
                                    <az-submit color="outline-success btn-sm" @click="checar(receita)">
                                        <i class="fa fa-check" aria-hidden="true"></i>
                                    </az-submit>
                                </template>
                                <template v-else>
                                    <h5 v-for="(items, status, irx) in stat_horarios(receita)" :key="irx">
                                        <span class="badge badge-secondary" v-if="status == 'A'">
                                            <i class="fa fa-question-circle" aria-hidden="true"></i>
                                            <span class="ml-2">{{ items.length }}</span>
                                        </span>
                                        <span class="badge badge-success" v-if="status == 'X'">
                                            <i class="fa fa-check-circle" aria-hidden="true"></i>
                                            <span class="ml-2">{{ items.length }}</span>
                                        </span>
                                        <span class="badge badge-warning" v-if="status == 'R'">
                                            <i class="fa fa-exclamation-circle" aria-hidden="true"></i>
                                            <span class="ml-2">{{ items.length }}</span>
                                        </span>
                                        <span class="badge badge-danger" v-if="status == 'C'">
                                            <i class="fa fa-times-circle" aria-hidden="true"></i>
                                            <span class="ml-2">{{ items.length }}</span>
                                        </span>
                                    </h5>
                                </template>
                            </div>
                        </div>
                    </td>
                </tr>
                <template v-if="receita.protocolo && receita.protocolo.infusao && receita.protocolo.infusao.proxima_marcacao">
                    <tr :key="'MARC' + index" class="table-secondary table-sm">
                        <td>
                            <div class="row">
                                <div class="col col-12 col-md-6 d-flex justify-content-between">
                                    <span class="ml-1">
                                        <a href="#" @click.prevent="editar_marcacao(receita.protocolo.infusao.proxima_marcacao)" class="card-link mr-2">
                                            <i class="fa-solid fa-circle-dot"></i>
                                        </a>

                                        <span class="mr-1">
                                            {{ receita.protocolo.infusao.proxima_marcacao.id_atendimento ? 'Atendimento:' : 'Próxima Marcação:' }} 
                                        </span>
                                        
                                        {{ $util.getFormatDate(receita.protocolo.infusao.proxima_marcacao.dt_inicio) }}
                                        {{ receita.protocolo.infusao.proxima_marcacao.dt_inicio.slice(11,16) }}
                                        <span v-if="receita.protocolo.infusao.proxima_marcacao.st_regiao" class="ml-2 badge badge-secondary">
                                            {{ receita.protocolo.infusao.proxima_marcacao.st_regiao }}
                                        </span>

                                        <span v-if="receita.protocolo.infusao.proxima_marcacao.id_atendimento" class="ml-2">
                                            #{{ receita.protocolo.infusao.proxima_marcacao.id_atendimento }}
                                        </span>

                                        <span class="badge badge-secondary ml-2" v-if="receita.protocolo.infusao.proxima_marcacao.in_qt_dia">C{{ receita.protocolo.infusao.proxima_marcacao.in_qt_ciclo }} / D{{ receita.protocolo.infusao.proxima_marcacao.in_qt_dia }}</span>

                                    </span>

                                    <div v-if="receita.protocolo.infusao.proxima_marcacao.st_observacoes">
                                        <az-float-panel
                                            classe="right"
                                            title="Observações"
                                            icon="fas fa-file-alt">
                                            <small class="lead">{{ receita.protocolo.infusao.proxima_marcacao.st_observacoes }}</small>
                                        </az-float-panel>
                                    </div>
                                </div>
                                <div class="col col-12 col-md-6 d-flex justify-content-between">
                                    <div>
                                        <template v-if="receita.protocolo.infusao.proxima_marcacao.autorizacao">
                                            Autorização: 
                                            <a href="#" @click="ver_autorizacao(receita.protocolo.infusao.proxima_marcacao)">
                                                <span class="badge ml-1" :class="'badge-' + receita.protocolo.infusao.proxima_marcacao.autorizacao.status_solicitacao.color">
                                                    {{ receita.protocolo.infusao.proxima_marcacao.autorizacao.status_solicitacao.msg }}
                                                </span>
                                            </a>
                                            <span class="ml-2 text-muted">
                                                S{{ receita.protocolo.infusao.proxima_marcacao.autorizacao.id_solicitacao_autorizacao }}
                                            </span>
                                        </template>
                                    </div>
                                    <div>
                                        <div class="dropleft d-flex align-items-center justify-content-center order-1 order-md-2 mr-1">
                                            <a href="#" role="button" id="dropdownMenuLink" data-toggle="dropdown" aria-haspopup="true" aria-expanded="false">
                                                <i class="fas fa-ellipsis-v"></i>
                                            </a>
                                            <div class="dropdown-menu" aria-labelledby="dropdownMenuButton">
                                                <button class="dropdown-item" @click="novoDocumento(receita.protocolo.infusao.proxima_marcacao)">
                                                    Emitir Documento
                                                </button>
                                            </div>
                                        </div>
                                    </div>
                                </div>
                            </div>
                        </td>
                    </tr>
                </template>
                <template v-if="receita.exibido">
                    <tr>
                        <td>
                            <ul class="nav nav-tabs" id="myTab" role="tablist">
                                <li class="nav-item" role="presentation">
                                    <button class="nav-link active" id="home-tab" data-toggle="tab" data-target="#home" type="button" role="tab" aria-controls="home" aria-selected="true">
                                        {{ receita.protocolo ? 'Prescrição do Protocolo' : 'Prescrição' }}
                                    </button>
                                </li>
                                <li class="nav-item" role="presentation" v-if="receita.protocolo && receitas_sessao(receita) && receitas_sessao(receita).length">
                                    <button class="nav-link" id="profile-tab" data-toggle="tab" data-target="#profile" type="button" role="tab" aria-controls="profile" aria-selected="false">
                                        Prescrição da Sessão
                                    </button>
                                </li>
                            </ul>
                            <div class="tab-content" id="myTabContent">
                                <div class="tab-pane fade show active" id="home" role="tabpanel" aria-labelledby="home-tab">
                                    <div class="alert alert-info small p-2 my-1 d-flex justify-content-between" v-if="receita.protocolo">
                                        <div>
                                            Prescrição do Protocolo, a ser aplicada nas sessões subsequentes agendas.
                                            <div v-if="get_marcacao(receita) && receitas_sessao(receita) && receitas_sessao(receita).length">
                                                A sessão do dia {{ $util.getFormatDate(get_marcacao(receita).dt_inicio) }} já possui uma prescrição específica, que pode ser visualizada na aba "Prescrição da Sessão".
                                            </div>
                                            <div v-else-if="get_marcacao(receita)">
                                                A sessão do dia {{ $util.getFormatDate(get_marcacao(receita).dt_inicio) }} fará uso dessa prescrição do protocolo.
                                            </div>
                                        </div>
                                        <div>
                                            <a href="#" @click.prevent="imprimir_prescricao(receita)" title="Imprimir Prescrição do Protocolo.">
                                                <i class="fa fa-print"></i>
                                            </a>
                                        </div>
                                    </div>

                                    <valid-ver-prescricao 
                                        :receita="receita" 
                                        :is_medico="is_medico" 
                                        :tem_sessao="receita.protocolo && receitas_sessao(receita) && receitas_sessao(receita).length" />
                                </div>
                                <div class="tab-pane fade" id="profile" role="tabpanel" aria-labelledby="profile-tab">
                                    <div class="alert alert-info small p-2 my-1 d-flex justify-content-between" v-if="get_marcacao(receita)">
                                        <div>
                                            Prescrição do Sessão: {{ $util.getFormatDate(get_marcacao(receita).dt_inicio) }}
                                        </div> 
                                        <div>
                                            <span class="mr-2" v-if="get_marcacao(receita).in_qt_dia">
                                                D{{ get_marcacao(receita).in_qt_dia }}
                                            </span>

                                            <span v-if="get_marcacao(receita).id_atendimento">
                                                #{{ get_marcacao(receita).id_atendimento }}                                           
                                            </span>

                                            <span v-else>
                                                Agendada
                                            </span>

                                            <a href="#" @click.prevent="imprimir_prescricao(receita)" title="Imprimir Prescrição da Sessão." class="ml-3">
                                                <i class="fa fa-print"></i>
                                            </a>
                                        </div>
                                    </div>

                                    <div v-for="(receita_sessao, irs) in receitas_sessao(receita)" :key="irs">
                                        <valid-ver-prescricao 
                                            :receita="receita_sessao" 
                                            :receita_base="receita"
                                            :tem_sessao="true" 
                                            :is_medico="is_medico" 
                                            :is_sessao="true"/>
                                        <hr>
                                    </div>
                                </div>
                            </div>
                        </td>
                    </tr>

                    <template v-if="false">
                        <template v-for="(medics, grupo, imx) in agrupar_receita(receita.items)">
                            <tr :key="'G' + index + 'M' + imx" v-if="grupo && grupo != 'null'">
                                <td class="table-info">
                                    <strong>{{ grupo }}</strong>
                                    <i class="fa-solid fa-circle-dot text-warning ml-2" title="Próxima Marcação" v-if="grupo && receita.protocolo && receita.protocolo.infusao && receita.protocolo.infusao.proxima_marcacao && receita.protocolo.infusao.proxima_marcacao.st_regiao && grupo == receita.protocolo.infusao.proxima_marcacao.st_regiao"></i>
                                </td>
                            </tr>
                            <template v-for="(medic, immx) in medics">
                                <tr :key="'P' + index + 'M' + imx + 'I' + immx" v-if="true">
                                    <td>
                                        <div class="row">
                                            <div class="col col-12 col-md-1">
                                                <az-audit-log-button model="receitaMedicamento" :id="medic.id_receita_medicamento" sizing="sm" class="ml-3" />
                                            </div>
                                            <div class="col col-12 col-md-9">
                                                <div v-if="medic.diluidos && medic.diluidos.length">
                                                    <div v-for="(diluido, idx) in medic.diluidos" :key="idx" class="mb-2">
                                                        <table class="table table-sm table-borderless p-0 m-0">
                                                            <tr>
                                                                <td class="py-0" width="1%"><i class="fa fa-plus fa-fw mr-1" aria-hidden="true"></i></td>
                                                                <td class="py-0">{{ diluido.item.st_medicamento }}</td>
                                                            </tr>
                                                            <tr v-if="diluido.quantidade">
                                                                <td class="py-0"></td>
                                                                <td class="text-muted py-0">{{ diluido.quantidade }}
                                                                    <span v-if="diluido.qtd_calc">
                                                                        <i class="fa fa-caret-right mx-2" aria-hidden="true"></i>
                                                                        {{ diluido.qtd_calc }}
                                                                    </span>
                                                                </td>
                                                            </tr>
                                                            <tr v-if="diluido.st_posologia">
                                                                <td class="py-0"></td>
                                                                <td class="py-0 text-muted">{{ diluido.st_posologia }}</td>
                                                            </tr>
                                                            <tr v-if="medic.st_observacoes">
                                                                <td class="py-0"></td>
                                                                <td class="py-0 text-muted">{{ medic.st_observacoes }}</td>
                                                            </tr>
                                                        </table>
                                                    </div>
                                                </div>
                                                <div :class="( medic.diluidos && medic.diluidos.length ) ? 'small' : ''">
                                                    <div>{{ ( medic.diluidos && medic.diluidos.length ) ? 'diluído em ' : '' }} {{ medic.item.st_medicamento }}</div>
                                                    <div class="text-muted">{{ medic.quantidade }}
                                                        <span v-if="medic.qtd_calc">
                                                            <i class="fa fa-caret-right mx-2" aria-hidden="true"></i>
                                                            {{ medic.qtd_calc }}
                                                        </span>
                                                    </div>
                                                    <div class="text-muted">{{ medic.st_posologia }}</div>
                                                    <div class="small text-muted" v-if="medic.st_observacoes">{{ medic.st_observacoes }}</div>
                                                </div>
                                                
                                            </div>
                                            <div class="col col-12 col-md-2">
                                                <div v-if="get_info_receita(receita).in_peso">Peso: {{ get_info_receita(receita).in_peso }} kg</div>
                                                <div v-if="get_info_receita(receita).in_altura">Altura: {{ $util.formatMoeda(get_info_receita(receita).in_altura) }} m</div>
                                                <div v-if="get_info_receita(receita).in_altura && get_info_receita(receita).in_peso">SC: {{ $util.formatMoeda($util.calc_sup_corp(get_info_receita(receita).in_peso, get_info_receita(receita).in_altura)) }} m2</div>
                                                <div v-if="get_info_receita(receita).dc_creatinina">Creatinina: {{ $util.formatMoeda(get_info_receita(receita).dc_creatinina) }} mg/dL</div>
                                                <div v-if="( get_info_receita(receita).in_altura || get_info_receita(receita).in_peso ) && get_info_receita(receita).dt_pesagem" title="Aferição" class="small text-muted">{{ $util.getFormatDate(get_info_receita(receita).dt_pesagem) }}</div>
                                            </div>
                                        </div>
                                    </td>
                                </tr>
                            </template>
                        </template>
                        <tr :key="'F' + index" v-if="is_medico">
                            <td class="d-flex justify-content-between">
                                <div>
                                    <template v-if="receita.protocolo && receita.protocolo.infusao && receita.protocolo.infusao.proxima_marcacao && !receita.protocolo.infusao.proxima_marcacao.id_atendimento">
                                        <button type="button" class="btn btn-primary mr-1" @click="editar_prescricao(receita, 'P')">
                                            Editar Protocolo
                                        </button>

                                        <button type="button" class="btn btn-info" @click="editar_prescricao(receita, 'S', receita.protocolo.infusao.proxima_marcacao.id_marcacao)">
                                            Editar Sessão
                                        </button>
                                    </template>

                                    <template v-else>
                                        <button type="button" class="btn btn-primary" @click="editar_prescricao(receita)">
                                            Editar
                                        </button>
                                    </template>
                                </div>
                                <div>
                                    <div v-if="receita.id_receita_editada" class="text-right">
                                        <span class="badge badge-primary">
                                            Editada ({{ receita.id_receita_editada }})
                                        </span>
                                    </div>

                                    <span v-if="receita.protocolo" class="text-right">
                                        <span class="badge badge-dark" v-if="receita.editada && receita.editada.id_marcacao_edicao">
                                            Prescrição da Sessão (M{{ receita.editada.id_marcacao_edicao }})
                                        </span>
                                        <span class="badge badge-dark" v-else>
                                            Prescrição do Protocolo
                                        </span>

                                        <div v-if="receita.protocolo.infusao" class="small text-muted">{{ receita.protocolo.infusao.id_infusao }}</div>
                                    </span>

                                    <span v-else-if="receita.anamnese.atendimento_procedimento.atendimento.marcacao && receita.anamnese.atendimento_procedimento.atendimento.marcacao.infusao" class="text-right">
                                        <span class="badge badge-warning">
                                            Prescrição da Sessão
                                        </span>
                                        <div class="small text-muted">{{ receita.anamnese.atendimento_procedimento.atendimento.marcacao.infusao.id_infusao }}</div>
                                    </span>
                                </div>
                            </td>
                        </tr>
                    </template>
                </template>
            </tbody>
        </table>

        <!-- Modal -->
        <div class="modal fade" id="aprazamentoModal" tabindex="-1" role="dialog" aria-labelledby="modelTitleId" aria-hidden="true">
            <div class="modal-dialog modal-xl modal-dialog-scrollable" role="document">
                <div class="modal-content" v-if="item">
                    <div class="modal-header">
                        <h5 class="modal-title">
                            Aprazar: 
                            {{ item.anamnese.atendimento_procedimento.atendimento.paciente.search }}
                        </h5>
                        <button type="button" class="close" data-dismiss="modal" aria-label="Close">
                            <span aria-hidden="true">&times;</span>
                        </button>
                    </div>
                    <div class="modal-body">
                        <table class="table table-hover">
                            <tr v-for="(medic, imx) in item.items" :key="imx">
                                <div class="row">
                                    <div class="col col-12 col-md-8">
                                        <div>{{ medic.item.st_medicamento }}</div>
                                        <div class="text-muted">{{ medic.quantidade }}</div>
                                        <div class="text-muted">{{ medic.st_posologia }}</div>
                                        <div class="small text-muted" v-if="medic.st_observacoes">{{ medic.st_observacoes }}</div>
                                    </div>
                                    <div class="col col-12 col-md-4">
                                        <div v-if="medic.js_prescricao_horarios">
                                            <div class="row no-gutters">
                                                <div class="col col-12 col-md-6" v-for="(horario, ihx) in medic.js_prescricao_horarios.horarios" :key="'M' + imx + '.H' + ihx">
                                                    <az-input
                                                        class="mr-1"
                                                        type="time"
                                                        required
                                                        :validate="validate"
                                                        v-model="horario.hora" />
                                                </div>
                                            </div>
                                        </div>

                                        <div class="btn-group" role="group" aria-label="Basic example">
                                            <div class="dropdown">
                                                <button class="btn btn-primary btn-sm dropdown-toggle" type="button" id="dropdownMenuButton" data-toggle="dropdown" aria-haspopup="true" aria-expanded="false">
                                                    {{ qtde }}
                                                </button>
                                                <div class="dropdown-menu" aria-labelledby="dropdownMenuButton">
                                                    <a class="dropdown-item" href="#" v-for="qtd in 6" @click.prevent="qtde = qtd" :key="qtd">
                                                        {{ qtd }}
                                                    </a>
                                                </div>
                                            </div>
                                            <button type="button" class="btn btn-primary btn-sm" @click="incluir_horario(medic)">
                                                <i class="fa fa-plus" aria-hidden="true"></i>
                                            </button>
                                        </div>
                                    </div>
                                </div>
                            </tr>
                        </table>

                        <br><br><br><br>

                        <pre v-if="false" class="alert alert-warning mt-3">{{ item }}</pre>
                    </div>
                    <div class="modal-footer">
                        <button type="button" class="btn btn-secondary" data-dismiss="modal">Fechar</button>
                        <az-submit @click="salvar_aprazamento()">Atualizar</az-submit>
                    </div>
                </div>
            </div>
        </div>

        <pre v-if="false && dados" class="alert alert-warning mt-3">{{ dados }}</pre>

        <!-- Inclusão de Paciente -->

        <div class="modal fade" id="novoPacientePrescricaoModal" tabindex="-1" role="dialog" aria-labelledby="modelTitleId" aria-hidden="true">
            <div class="modal-dialog modal-xl" role="document">
                <div class="modal-content" v-if="dados_novo_paciente">
                    <div class="modal-header">
                        <h5 class="modal-title">Incluir Paciente</h5>
                        <button type="button" class="close" data-dismiss="modal" aria-label="Close">
                            <span aria-hidden="true">&times;</span>
                        </button>
                    </div>
                    <div class="modal-body">
                        <div class="mb-2" v-if="!dados_novo_paciente.id_pessoa && !dados_novo_paciente.verificado">
                            <cadastro-paciente-primeira-vez ref="cadPaciente1" :direto="true" v-model="dados_novo_paciente" />
                        </div>
                        <div class="mb-2" v-else>
                            <cadastro-paciente
                                v-model="dados_novo_paciente"
                                formName="cadpac"
                                :editar="true"
                                :noButtons="true"
                                ref="cadPaciente"
                                :validate="validate"
                            />
                        </div>    
                    </div>
                    <div class="modal-footer">
                        <button type="button" class="btn btn-secondary" data-dismiss="modal">Cancelar</button>
                        <az-submit v-if="dados_novo_paciente.verificado" @click="salvar_paciente()">Incluir</az-submit>
                    </div>
                </div>
            </div>
        </div>

        <!-- Fim Inclusão de Paciente -->

        <registrar-contatos 
                titulo="Validação"
                :lista_status="lista_status_edicao" 
                :block_origem="lista_status_block_edicao"
                :id_marcacao="edicao ? edicao.valid_id_marcacao : null"
                :extra_parms="{ valid_prescr: true }"
                ref="regcontatos" 
                @refresh="load()">
                <template v-slot:info>
                    <div v-if="false">
                        <pre>{{ edicao }}</pre>
                    </div>
                    <template v-if="edicao">
                        <div>
                            <div>
                                {{ edicao.anamnese.atendimento_procedimento.atendimento.paciente.st_nome }}
                                <small class="text-muted">
                                    {{ edicao.anamnese.atendimento_procedimento.atendimento.paciente.cadastro.sexo }},
                                    {{ edicao.anamnese.atendimento_procedimento.atendimento.paciente.cadastro.idade }}
                                </small>
                            </div>
                            <div class="small">{{ edicao.anamnese.atendimento_procedimento.atendimento.plano.search }}</div>
                            <div class="small">{{ edicao.anamnese.atendimento_procedimento.atendimento.medico.search }}</div>
                        </div>
                        <div>
                            <div class="small mb-2" v-if="edicao.anamnese.atendimento_procedimento.procedimento">
                                <div>{{ edicao.anamnese.atendimento_procedimento.procedimento.search }}</div>
                                <div v-if="edicao.anamnese.atendimento_procedimento.atendimento.marcacao && edicao.anamnese.atendimento_procedimento.atendimento.marcacao.infusao">
                                    {{ edicao.anamnese.atendimento_procedimento.atendimento.marcacao.infusao.st_titulo }}
                                </div>
                                <div class="text-muted">#{{ edicao.anamnese.atendimento_procedimento.id_atendimento }}</div>
                            </div>
                        </div>
                        <hr>
                        <div v-if="edicao.kit" class="small">{{ edicao.kit.st_nome }}</div>
                        <div v-if="edicao.procedimento" class="small">{{ edicao.procedimento.search }}</div>
                    </template>
                </template>
        </registrar-contatos>

        <order-set
            v-if="edicao_prescricao"
            title="Prescrição"
            v-model="edicao_prescricao"
            service="medicamentos.index"
            :tem_infusao="false"
            name="receita"
            ref="receita"
            :id_anamnese="edicao_prescricao_base.id_anamnese"
            :atendimento="edicao_prescricao_base.anamnese.atendimento_procedimento.atendimento"
            :id_paciente="edicao_prescricao_base.anamnese.atendimento_procedimento.atendimento.id_paciente"
            @refresh="load()"
            :validprescr="true"
        ></order-set>

        <agendar-infusao ref="aginf" />
        <novo-atendimento-avulso ref="avulso" :id_unidade_operacao="filtro.id_unidade_operacao" />
        <editar-peso-altura-prescricao ref="pesoaltura" @refresh="load" />
        <pep-view-receitas ref="viewreceitas" />
        <ver-autorizacao ref="ver_autorizacao" />

        <!-- Documentos -->
        <documento ref="documento" :recepcao="false" :pep_livre="true" refresh="imprimir_documento" />

    </div>
</template>

<script>
import _ from 'lodash';
import $ from 'jquery';
import AzPeriodo from '../../shared/forms/AzPeriodo.vue';
import AzInput from '../../shared/forms/AzInput.vue';
import AzEmptyState from '../../util/AzEmptyState.vue';
import AzSubmit from '../../util/AzSubmit.vue';
import AzAuditLogButton from '../../util/AzAuditLogButton.vue';
import RegistrarContatos from '../../shared/RegistrarContatos.vue';
import OrderSet from '../consultorio/OrderSet.vue';
import AgendarInfusao from './AgendarInfusao.vue';
import CadastroPacientePrimeiraVez from '../recepcao/CadastroPacientePrimeiraVez.vue';
import CadastroPaciente from "../../shared/CadastroPaciente.vue";
import NovoAtendimentoAvulso from '../consultorio/NovoAtendimentoAvulso.vue';
import AzFloatPanel from "../../util/AzFloatPanel.vue";
import Documento from '../consultorio/Documento.vue';
import EditarPesoAlturaPrescricao from './EditarPesoAlturaPrescricao.vue';
import PepViewReceitas from '../consultorio/PepViewReceitas.vue';
import ValidVerPrescricao from './ValidVerPrescricao.vue';
import VerAutorizacao from '../recepcao/VerAutorizacao.vue';

export default {
    data () { 
        return { 
            referencia: this.$util.hoje(), 
            search: "", 
            dados: null, 
            item: null, 
            qtde: 1, 
            validate: false, 
            filtro: { 
                periodo: 'h', 
                tipo_data: "", 
                id_unidade_operacao: this.$util.getCookie('id_unidade_operacao'),
                id_fila_laudo: "", 
                id_medico: "", 
                id_contato_status: "", 
                id_procedimento_protocolo: "", 
                paciente: "", 
                status_autorizacao: "", 
            },
            filas: [], 
            lista_status: [], 
            edicao: null, 
            edicao_prescricao: null, 
            edicao_prescricao_base: null, 
            lista_status_autorizacao: [
                { id: 0, search: 'Aberto' },
                { id: 6, search: 'Enviado' },
                { id: 1, search: 'Autorizado' },
                { id: 9, search: 'On-line' },
                { id: 2, search: 'Em análise' },
                { id: 3, search: 'Negado' },
                { id: 4, search: 'Aut. Parcial' },
                { id: 5, search: 'Cancelado' },
                { id: 10, search: 'Em Sessão' },
                { id: 11, search: 'Pendente' },
            ],
            dados_novo_paciente: null, 
        }
    },

    props: ['enfermagem'],

    components: { 
        AzInput, 
        AzEmptyState, 
        AzSubmit, 
        AzAuditLogButton, 
        RegistrarContatos, 
        AzPeriodo, 
        OrderSet, 
        AgendarInfusao, 
        CadastroPacientePrimeiraVez,
        CadastroPaciente, 
        NovoAtendimentoAvulso, 
        AzFloatPanel, 
        Documento, 
        EditarPesoAlturaPrescricao, 
        PepViewReceitas, 
        ValidVerPrescricao, 
        VerAutorizacao
    },

    computed: { 
        lista: function () { 
            if ( !this.dados )
                return [];

            return this.dados.lista;
        },

        lista_status_edicao: function () { 
            return ( this.dados && this.dados.lista_status ) 
                ? this.dados.lista_status.filter(item => item.tem_acesso && item.fl_ativo) 
                : [];
        },

        lista_status_block_edicao: function () { 
            return ( this.dados && this.dados.lista_status ) 
                ? this.dados.lista_status.filter(item => !item.tem_acesso_origem && !isNaN(item.id_contato_status))
                    .map(item => item.id_contato_status) 
                : [];
        },

        is_medico: function () { 
            if ( this.$store.state.user.medico 
                && this.$store.state.user.medico.conselho 
                && this.$store.state.user.medico.conselho.st_sigla != 'COREN' ) { 

                return true;

            }
            
            return false;
        },

        lista_por_status: function () { 
            if  ( !this.dados || !this.dados.lista ) { 
                return [];
            }

            return _.map(
                _.groupBy(this.dados.lista, 'contato.id_contato_status'),
                (value, key) => { 
                    return { 
                        id_contato_status: ( key && key != 'undefined' ) ? key : 'R',
                        titulo: _.get(value, '0.contato.contato_status.search', 'Registrado'), 
                        cor: _.get(value, '0.contato.contato_status.st_color', 'secondary'),
                        qtde: value.length, 
                    };
                }
            );

        },
        
    },

    methods: { 
        imprimir_prescricao(order, cert = false) { 
            if ( this.pep ) { 
                this.$util.print_preview('imprimir/' + ( cert ? 'doc_certificado/' : '' ) + order.model.type + '/' + order.model.id, true, { noass: 1 }, true);  
            } else { 
                this.$util.print_preview('imprimir/' + ( cert ? 'doc_certificado/' : '' ) + order.model.type + '/' + order.model.id, true);
            }
        },

        ver_autorizacao (marcacao) { 
            this.$refs.ver_autorizacao.abrir(marcacao);
        },

        is_receita_de_sessao (receita) { 
            if ( !receita ) { 
                return false; 
            }
            
            if ( receita && receita.id_marcacao_edicao ) { 
                return true; 
            }

            return ( receita
                && receita.anamnese 
                && receita.anamnese.atendimento_procedimento 
                && receita.anamnese.atendimento_procedimento.atendimento.marcacao 
                && receita.anamnese.atendimento_procedimento.atendimento.marcacao.infusao ) ? true : false; 
        },

        get_marcacao (receita) { 
            if ( receita.protocolo 
                && receita.protocolo.infusao
                && receita.protocolo.infusao.marcacoes
                && receita.protocolo.infusao.marcacoes.length == 1 
            ) { 
                return _.first(receita.protocolo.infusao.marcacoes);
            }

            return; 
        },

        receitas_sessao(receita) { 

            if ( receita    
                && receita.protocolo 
                && receita.protocolo.infusao
                && receita.protocolo.infusao.marcacoes
                && receita.protocolo.infusao.marcacoes.length == 1 
                && receita.protocolo.infusao.marcacoes[0].id_atendimento
            ) { 
                return receita.protocolo.infusao.marcacoes.flatMap(marcacao => marcacao.atendimento_procedimentos.flatMap(ap => ap.anamnese ? ap.anamnese.receita : []));
            }

            if ( receita.sessao ) { 
                return [
                    receita.sessao
                ];
            }

            return; 

        },

        resumo_medicamentos (receita) { 
            let atendimento = receita.anamnese.atendimento_procedimento.atendimento;

            this.$util.loadItem(this, { 
                service: 'marcacoes',
                func: 'index',
                parms: { 
                    id_paciente: atendimento.id_paciente, 
                    receitas: true, 
                }
            })
            .then(res => { 
                this.$refs.viewreceitas.abrir(res, atendimento);
            });
        },

        get_info_receita (receita) { 
            return ( receita && receita.editada ) ? receita.editada : receita; 
        },

        cor_contato (receita) { 
            if ( receita && receita.contato && receita.valid_id_marcacao && receita.contato.id_marcacao != receita.valid_id_marcacao ) { 
                return 'light text-muted';
            }

            return ( receita && receita.contato && receita.contato.contato_status ) ? receita.contato.contato_status.st_color : 'secondary';
        },

        quando (data) { 
            if ( data && data.slice(0,10) == this.$util.hoje() ) { 
                return 'Hoje'
            } else { 
                return this.$util.getFormatDate(data, 'DD/MM');
            }
        },  

        editar_peso_altura (receita) { 
            if ( receita.editada ) { 
                this.$refs.pesoaltura.abrir(receita.editada);    
            } else { 
                this.$refs.pesoaltura.abrir(receita);
            }
        },

        novoDocumento (marcacao) { 
            console.log('novoDoc', marcacao);
            this.$refs.documento.novoDocumento(marcacao);
        },

        editar_marcacao(marcacao) { 
            if ( marcacao ) { 
                this.$root.editar_marcacao(marcacao.id_marcacao, () => { 
                    this.load();
                });
            }
        },

        agrupar_receita(lista) { 
            return _.groupBy(lista, 'st_agrupa');
        },

        novo_avulso () { 
            this.$refs.avulso.novo_atendimento_avulso(null, this.filtro.paciente.id_pessoa);
        },

        incluir_paciente () { 
            this.validate = false; 
            this.dados_novo_paciente = null;

            this.$nextTick(() => { 
                this.dados_novo_paciente = { 
                    id_pessoa: null,
                    verificado: false, 
                    st_nome: "", 
                    cpf_nao_obrigatorio: false, 
                    cadastro: { 
                        ch_sexo: "",
                        dt_nascimento: "", 
                        fl_estrangeiro: false, 
                        st_cpf: "", 
                        st_nome_mae: "",
                        st_rg: "", 
                        telefones: { 
                            telefone: "",
                            celular: "", 
                        },
                        endereco: { 
                            cidade: null, 
                        }, 
                    },
                    paciente_unidade: { 
                        st_numero_carteira: "", 
                        dt_validade_carteira: "",
                        st_numero_prontuario: "", 
                    },
                };

                $('#novoPacientePrescricaoModal').modal('show');
            })
        },

        salvar_paciente () {

            this.$util.atualizar(this, { 
                service: 'pacientes', 
                func: 'store',
                dados: { 
                    paciente: this.dados_novo_paciente,
                },
                modal: 'novoPacientePrescricaoModal',
                callback: res => { 
                    this.filtro.paciente = res;
                }
            });
    
        },
        
        abrir_perfil(paciente) { 
            this.$root.perfil(paciente);
        },

        agendar_infusao (receita) { 
            this.$refs.aginf.abrir(receita);
        },

        editar_prescricao (receita, tipo_edicao = '', id_marcacao = null, receita_base = null) { 
            this.edicao_prescricao_base = _.cloneDeep(receita_base || receita);
            this.edicao_prescricao = receita.editada ? _.cloneDeep(receita.editada) : _.cloneDeep(receita);

            this.edicao_prescricao.tipo_edicao = tipo_edicao;
            this.edicao_prescricao.id_marcacao_edicao = id_marcacao;
            
            this.$nextTick(() => { 
                console.log(this.$refs);
                this.$refs.receita.abrir(this.edicao_prescricao);
            });
        },
        filtrar_status (id_contato_status) { 
            if ( this.filtro.id_contato_status == id_contato_status ) { 
                this.filtro.id_contato_status = "";
            } else { 
                this.filtro.id_contato_status = id_contato_status;
            }

            this.load();
        },

        abrir_contatos (item = null) { 
            this.edicao = _.cloneDeep(item); 
            this.$refs.regcontatos.editar(this.edicao);
        },

        solicitar_matmed (receita) { 
            let solicgeral = this.$util.get_solic_geral();

            if ( solicgeral ) { 

                receita.anamnese.atendimento_procedimento.atendimento.marcacao.nome_paciente = receita.anamnese.atendimento_procedimento.atendimento.paciente.st_nome;
                
                solicgeral.solicitar(
                    'S', 
                    { 
                        ...receita, 
                        id_estoque_solicitacao: receita.solicitacao ? receita.solicitacao.id_estoque_solicitacao : null, 
                        marcacao: receita.anamnese.atendimento_procedimento.atendimento.marcacao
                    },
                    () => { 
                        this.load();
                    }
                );

            }
        },

        copiar_checagem(receita, horario) { 
            receita.items.forEach(item => { 
                if ( item.js_prescricao_horarios && item.js_prescricao_horarios.horarios ) { 
                    item.js_prescricao_horarios.horarios = item.js_prescricao_horarios.horarios.map(() => { 
                        return _.cloneDeep(horario);
                    });
                }
            });
        },

        stat_horarios (receita) { 
            return _.groupBy(
                receita.items.flatMap(item => item.js_prescricao_horarios ? item.js_prescricao_horarios.horarios : []),
                'status'
            );
        },

        checar (receita) {
            this.$util.atualizar(this, { 
                service: 'enfermagem',
                func: 'checar',
                dados: receita,
                toast: true, 
                reload: true, 
            });
        },

        cor_status (horario) { 
            if ( !horario && !horario.status )
                return;

            switch (horario.status) {
                case 'A': return 'fa fa-question-circle';
                case 'X': return 'fa fa-check-circle text-success';
                case 'R': return 'fa fa-exclamation-circle text-warning';
                case 'C': return 'fa fa-times-circle text-danger';
            }
        },

        aprazados (receita) { 
            return receita.items.find(item => item.js_prescricao_horarios && item.js_prescricao_horarios.horarios.length) ? true : false;
        },

        incluir_horario (medic) { 
            if ( !medic.js_prescricao_horarios ) { 
                medic.js_prescricao_horarios = { 
                    horarios: [],
                };
            }

            for (let index = 0; index < this.qtde; index++) {
                
                medic.js_prescricao_horarios.horarios.push({ 
                    hora: "",
                    status: "A", 
                    obs: "",
                });

            }
        },

        aprazar (receita) { 
            this.item = _.cloneDeep(receita);

            this.$nextTick(() => { 
                $('#aprazamentoModal').modal('show');
            });
        },

        tratar_paciente (atendimento) { 
            return { 
                marcacao: atendimento
            };
        },

        tratar_procedimento (receita) { 
            return { 
                marcacao: { 
                    procedimento: receita.anamnese.atendimento_procedimento.procedimento,
                    medico: receita.anamnese.atendimento_procedimento.atendimento.medico, 
                }
            };
        },

        salvar_aprazamento () { 
            this.$util.atualizar(this, { 
                service: 'enfermagem',
                func: 'aprazar',
                dados: this.item,
                modal: 'aprazamentoModal',
                reload: true, 
            });
        },

        load() { 

            this.$util.setCookie('valid-prescr-fila', this.filtro.id_fila_laudo ? this.filtro.id_fila_laudo : '');
            this.$util.setCookie('inf-vp-per', this.filtro.periodo ? this.filtro.periodo : '');

            if ( !this.enfermagem ) {
                this.$util.setCookie('inf-vp-td', this.filtro.tipo_data ? this.filtro.tipo_data : '');
            }
            
            this.$store.state.user.assist_id_medico = this.filtro.id_medico;

            this.$util.load(this, { 
                service: this.enfermagem ? 'enfermagem' : 'infusao',
                func: 'aprazamentos',
                parms: { 
                    referencia: this.referencia, 
                    ...this.filtro, 
                    valid_prescr: true, 
                },
            });
        }
    },

    beforeMount() { 
        if ( this.$store.state.user.assist_id_medico ) { 
            
            this.filtro.id_medico = this.$store.state.user.assist_id_medico;

        } else if ( this.$store.state.user.medico 
            && this.$store.state.user.medico.conselho 
            && this.$store.state.user.medico.conselho.st_sigla != 'COREN' ) { 

            // this.filtro.id_medico = this.$store.state.user.medico.id_pessoa;

        }

        this.filtro.id_fila_laudo = this.$util.getCookie('valid-prescr-fila');

        //

        let per = this.$util.getCookie('inf-vp-per');

        if ( per && per != 'undefined' ) {
            this.filtro.periodo = per;
        }

        //

        let tipo_data = this.$util.getCookie('inf-vp-td');

        if ( tipo_data && tipo_data != 'undefined' ) {
            this.filtro.tipo_data = tipo_data;
        }
        
    },

    mounted() { 
        if ( this.enfermagem ) { 
            this.$store.commit("setBreadcrumb", [
                { name: "Assistência", path: "/assistencia/atend" },
                { name: "Validação Prescrição", path: "/assistencia/valid" },
            ]);

            this.filtro.tipo_data = ''; 
        } else { 
            this.$store.commit("setBreadcrumb", [
                { name: "Infusão", path: "/infusao/valid" },
                { name: "Validação Prescrição", path: "/infusao/valid" },
            ]);
        }

        this.load();

        let parms = { 
            enfermagem: true, 
        };

        this.$util.loadItem(this, { 
            service: 'fila_laudos',
            func: 'index',
            parms: parms
        })
        .then(res => { 
            this.filas = res

            if ( res && res.length == 1 ) { 
                this.filtro.id_fila_laudo = res[0].id_fila_laudo;
            }
        });


    }
}
</script>